import React from "react";
import "../../components/ChargesList/ChargesList.css";
import CheckIcon from "@mui/icons-material/Check";
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SearchIcon from '@mui/icons-material/Search';


const ChargesList = ({userDetailResponse, setOpenProfile, openProfile}) => {
    //console.log(userDetailResponse);
  return (
    <div className="container-fluid">
      
      <div className="chargesList">
        <table>
          <tr className="chargesListHeading">
            <th>S no.</th>
            <th>Description</th>
            <th>Quantity</th>
            <th>Selling Ex-GST</th>
            <th>Delivery Charges</th>
            <th>Height</th>
            <th>Selling Ex-GST</th>
            <th>Delivery Charges</th>
            <th>Action</th>
           
          </tr>

<tr>
<td>01</td>
<td>DOOR DELIVERY(BUBAI,EMIRATES,CAT)</td>
<td>01</td>
<td>₹ 52,416</td>
<td>-</td>
<td>18%</td>
<td>₹ 30,508</td>
<td>₹ 30,508</td>
<td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
</tr>

          {/* {userDetailResponse !== null ? (
    userDetailResponse.map((user) => (
        <tr key={user.id}>
            <td>1</td>
            <td>{user.name}</td>
            <td>{user.designation}</td>
            <td>kumud@gmail.com</td>
            <td>8976789534</td>
            <td>{user.designation}</td>
            <td>kumud@gmail.com</td>
            <td>{user.designation}</td>
            <td>kumud@gmail.com</td>
            <td>
                <button className="Statusbutton">
                    <CheckIcon className="icon" />
                    Active
                </button>
            </td>
            <td>
            <button style={{ height: "35px", width: "35px", backgroundColor: "#F1F1F1"}} onClick={() => setOpenProfile(!openProfile)}>
                    <EditOutlinedIcon className="icon" />
                </button>
                <button style={{ height: "35px", width: "35px", marginLeft: "5px", backgroundColor: "#F4616F", borderColor: "#FF0000"}} >
                    <DeleteOutlinedIcon className="icon" />
                </button>
            </td>
        </tr>
    ))
) : (
    <p>empty</p>
)} */}
         
          
        </table>
      </div>
    </div>
  );
};

export default ChargesList;
